"use client";

import * as React from "react";

import { HeroCanvasBleedShell } from "@hero-app/components/hero-canvas-bleed-shell";
import { HERO_RUNTIME_SCRIPT_PATH } from "@hero-app/lib/runtime";
import { IframeDashboard } from "./iframe-dashboard";

function loadEditorRuntimeOnce(): void {
  if (document.querySelector('script[data-soffi-runtime="1"]')) return;

  // The hero dashboard reaches this iframe through the `@hero-app` alias, which
  // Turbopack emits as a vendor chunk — that collapses every element's React
  // debug-source to a single file:line. The runtime's default "ordinal"
  // identity strategy then can't tell same-tag siblings apart, so style/prop
  // edits resolve to the wrong element. "hybrid" adds a content fingerprint
  // that disambiguates them. Must be set before the runtime script executes.
  window.__soffiConfig = {
    ...window.__soffiConfig,
    identityStrategy: "hybrid",
  };

  const script = document.createElement("script");
  script.src = HERO_RUNTIME_SCRIPT_PATH;
  script.dataset.soffiRuntime = "1";
  document.head.appendChild(script);
}

export function IframeRootPageClient() {
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  React.useEffect(() => {
    if (!mounted) return;
    loadEditorRuntimeOnce();
  }, [mounted]);

  if (!mounted) return null;

  return (
    <HeroCanvasBleedShell>
      <IframeDashboard />
    </HeroCanvasBleedShell>
  );
}
